import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Capitalizes the first letter of a string
 * @param string - String to capitalize
 * @returns Capitalized string or original if empty/null/undefined
 */
export function capitalizeFirstLetter(string) {
    if (!string) {
        return string;
    }
    return `${string[0].toUpperCase()}${string.slice(1)}`;
}
/**
 * Formats a skill's years of experience with correct pluralization
 * @param years - Years value (e.g., "1", "2+")
 * @returns Formatted string, e.g. "1 year" or "2+ years"
 */
export function formatSkillYears(years) {
    return `${years} ${years === "1" ? "year" : "years"}`;
}
/**
 * Tech Link component
 * @param href - URL to link to
 * @param children - Link content (e.g., icon or text)
 * @returns JSX anchor element that opens in a new tab
 */
export function TechLink({ href, children, }) {
    return (_jsx("a", { href: href, target: "_blank", rel: "noopener noreferrer", children: children }));
}
/**
 * Footer Links component
 * @param links - Array of footer link objects containing href, label
 * @returns JSX list of footer text links
 * External links (GitHub, LinkedIn) open in a new tab; mailto links open the
 * visitor's mail client in the current tab instead.
 */
export function FooterLinks({ links }) {
    return (_jsx("ul", { className: "footer-links", role: "list", children: links.map((link) => {
            const isMailto = link.href.startsWith("mailto:");
            return (_jsx("li", { children: _jsx("a", { href: link.href, className: "footer-link", target: isMailto ? undefined : "_blank", rel: isMailto ? undefined : "noreferrer", children: link.label }) }, link.href));
        }) }));
}
